import throttle from "just-throttle";

import { hangDown } from "@/Services/TherapyApi/VideoCalls";
import type { VIDEO_CALL_COMPLETE_REASON } from "@/Modules/Models/Api/VideoCalls";

const endVideoCall = async (roomId: string, reason?: VIDEO_CALL_COMPLETE_REASON): Promise<unknown> => {
  return hangDown(roomId, reason);
};

export default throttle(endVideoCall, 2000, { leading: true, trailing: false });
